<template>
	<SimpleModalComponent
		heading="Start a new discussion"
		@close-modal="emit( 'close-modal' )"
	>
		<template #content>
			<div class="form__set mb-16">
				<label
					for="new_tag"
					class="form__label"
				>
					Subject
				</label>
				<input
					id="discussion_subject"
					v-model="discussion_subject"
					class="form__input form__input--stretch"
					type="text"
					name="discussion_subject"
					placeholder="Type the subject of the message..."
					:disabled="loading"
					@keyup.enter="submitNewTag"
				>
			</div>

			<CommentFormComponent
				ref="comment-form"
				:discussion-id="discussion.id"
				:hide-buttons="true"
				comment-type="discussion"
				@comment-posted="finishDiscussionCreation"
			/>

			<p
				v-if="error_message"
				class="error-message"
			>
				{{ error_message }}
			</p>
		</template>

		<template #buttons>
			<button
				class="button"
				@click="emit( 'close-modal' )"
			>
				Cancel
			</button>
			<button
				class="button button--fill"
				:class="{ 'button--loading' : loading }"
				:disabled="!discussion_subject || !comment_has_content"
				@click="createNewDiscussion"
			>
				Post
			</button>
		</template>
	</SimpleModalComponent>
</template>

<script setup>
import SimpleModalComponent from './SimpleModalComponent.vue';
import CommentFormComponent from '../CommentFormComponent.vue';

import { ref, computed, useTemplateRef, nextTick, defineEmits } from 'vue';
import { useDataStore } from '../../stores/data';
import { useRoute } from 'vue-router';

const emit = defineEmits( ['confirm', 'close-modal', 'discussion-created'] );

const { createDiscussion } = useDataStore();
const route = useRoute();

const loading = ref( false );
const discussion_subject = ref( '' );
const discussion = ref( false );
const error_message = ref( null );

const comment_form = useTemplateRef( 'comment-form' );

const comment_has_content = computed( () => {
	return comment_form.value.content && comment_form.value.content.length > 0;
} );

const createNewDiscussion = async() => { // eslint-disable-line snakecasejs/snakecasejs
	error_message.value = null;
	loading.value = true;

	if ( !discussion_subject.value || !comment_has_content.value ) {
		loading.value = false;
		return;
	}

	try {
		const response = await createDiscussion( {
			project_id: parseInt( route.params.project_id ),
			subject: discussion_subject.value
		} );
		if ( response.data.save_project_discussions_discussion_Entry ) {
			discussion.value = response.data.save_project_discussions_discussion_Entry;
			await nextTick();
			comment_form.value.submitComment();
		}
	} catch ( error ) {
		error_message.value = error;
		loading.value = false;
	}
};

const finishDiscussionCreation = () => { // eslint-disable-line snakecasejs/snakecasejs
	emit( 'discussion-created', discussion.value );
};
</script>